var exports = {
  "kL": "xcc377c0b--9c10a1--container",
  "om": "xcc377c0b--9c10a1--block",
  "lG": "xcc377c0b--9c10a1--block--opened",
};

module.exports = exports;
